import React from "react";
import Button from "src/components/Button";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import AuthLayout from "src/components/layout/AuthLayout/AuthLayout";
import useTenant from "src/hooks/api/services/tenants/useTenant";
import useGlobal from "src/hooks/api/useGlobal";

function SignupChooseView({ t }: Translation) {
	const { tenant } = useTenant();
	const { global } = useGlobal();

	return (
		<AuthLayout
			head={{
				title: t("title"),
				back: {
					to: "/login",
					label: t("back"),
				},
			}}
		>
			<div className="flex flex-col gap-4">
				<p>
					{t("description", {
						tenant: tenant.name,
						students: global.students,
					})}
				</p>
				<p>{t("choose")}</p>
				<div className="flex flex-col sm:flex-row sm:flex-wrap justify-items-stretch items-stretch gap-4 my-4">
					<Button to="/signup/student" type="primary">
						{t("options.student")}
					</Button>
					<Button to="/signup/company" type="dark">
						{t("options.company")}
					</Button>
				</div>

				<strong>
					{t("cta", {
						students: global.students,
					})}
				</strong>
			</div>
		</AuthLayout>
	);
}

SignupChooseView.locale = {
	nl: {
		title: "Aanmelden",
		back: "Terug naar login",
		description:
			"Bij {{tenant}} kan je opdrachten uitvoeren voor verschillende opdrachtgevers. Opdrachtgevers kunnen gemakkelijk via hun eigen account opdrachten uitbesteden.",
		choose: "Als jong talent kies je voor 'Opdrachten uitvoeren', als bedrijf kies je voor 'Opdrachten plaatsen'",
		cta: "Join meer dan {{students}} jonge talenten",
		options: {
			student: "Opdrachten uitvoeren",
			company: "Opdrachten plaatsen",
		},
	},
	en: {
		title: "Signup",
		back: "Back to login",
		description:
			"At {{tenant}} you can complete tasks for various companies. Companies can easily outsource there tasks via there own account.",
		choose: "As young talent you choose 'Complete tasks', as company you choose 'Outsource tasks'",
		cta: "Join more than {{students}} young talents",
		options: {
			student: "Complete tasks",
			company: "Outsource tasks",
		},
	},
};
export default withTranslation(SignupChooseView);
